import React from 'react';
import { CheckCircle, X, Clock, MessageCircle } from 'lucide-react';
import './SuccessModal.css';

const SuccessModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <div className="modal-content">
          <div className="modal-icon-success">
            <CheckCircle size={64} strokeWidth={1.5} />
          </div>
          
          <h2 className="modal-title">
            Thank You for Choosing House of Microgreens 🌿
          </h2>
          
          <p className="modal-message">
            Your order has been confirmed.
          </p>
          
          <div className="modal-info-cards">
            <div className="info-card">
              <div className="info-icon">
                <Clock size={24} />
              </div>
              <div className="info-content">
                <h3>Delivery Window</h3>
                <p>7–10 days</p>
                <small>Freshly grown microgreens take time, but they're worth the wait.</small>
              </div>
            </div>
            
            <div className="info-card">
              <div className="info-icon">
                <MessageCircle size={24} />
              </div>
              <div className="info-content">
                <h3>Stay Updated</h3>
                <p>We'll update your order status on WhatsApp</p>
              </div>
            </div>
          </div>
          
          <button className="btn-modal-primary" onClick={onClose}>
            Got it, Thanks!
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
